export default function (Vue) {
  const VueFormatNumberFilter = (value) => {
    if (value || value === 0) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }

  Vue.filter('formatNumber', VueFormatNumberFilter)
}



// WEBPACK FOOTER //
// ./src/modules/filters/FormatNumber.js